exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-center[data-v-70a35bdc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.selWidth[data-v-70a35bdc]{width:320px}.order-detail-dialog[data-v-70a35bdc]{font-size:15px;color:#222}.section[data-v-70a35bdc]{margin-bottom:24px}.section-title[data-v-70a35bdc]{font-weight:bold;margin-bottom:8px;font-size:16px}.row[data-v-70a35bdc]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-bottom:4px;gap:32px}.el-table th[data-v-70a35bdc],.el-table td[data-v-70a35bdc]{text-align:center}", ""]);

// exports
